import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import(`./components/login/login.module`).then((m) => m.LoginModule)
  },
  {
    path: 'home',
    loadChildren: () => import(`./components/layout/layout.module`).then((m) => m.LayoutModule),
 
  },
  {
    path: '**',
    redirectTo: '' // optional fallback
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
